<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})"><i class="fas fa-long-arrow-alt-left"></i>&nbsp; <b>Home</b></a>
                    </span>
                </div>
            </div>
            <div class="profile-section pt-2">
                 <div class="transactions-container">

                  <!-- Summary Section -->
                  <div class="summary-section mb-4">
                      <div class="row">
                          <div class="col-6 col-md-3" v-for="(value, key) in summaryStats" :key="key">
                              <div class="summary-box" @click="applyFilter(key)" :class="{'active-filter': selectedFilter === key}">
                                  <div class="summary-label">{{ key }}</div>
                                  <div class="summary-value">{{ value }}</div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <!-- Clear Filter Button -->
                  <div class="clear-filter">
                      <button v-if="selectedFilter" @click="clearFilter">Clear Filter</button>
                  </div>

                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="mb-0">Transactions History</h6>
                    </div>

                    <!-- Transaction Items -->
                    <div class="transaction-item" v-for="payment in filteredPaymentHistoryData" :key="payment._id">
                        <div class="transaction-icon"><img :src="payment.imageUrl" height="30px" width="30px" /></div>
                        <div class="transaction-details">
                            <div class="transaction-title">{{ payment.productName }}
                              <!--<span class="badge badge-warning" v-if="payment.isTrialPeriod == true">Trial</span>-->
                            </div>
                            <small class="transaction-title" v-if="payment.subscriptionCode">
                              Subscription Code: {{ payment.subscriptionCode }} 
                              <span class="badge badge-danger" v-if="payment.subscriptionCodeUsed == true">Used</span>
                              <span class="badge badge-danger ml-1" v-if="new Date(payment.expiryAt) < today">Expired</span>
                            </small>
                            <small v-if="payment.profileName"><br v-if="payment.subscriptionCode"><b>Device Name:</b>  {{ payment.profileName }} ( {{ payment.serialNumber }} ) </small>
                            <div class="transaction-time" v-if="payment.expiryAt">Expire On: {{ HumanReadableDateFormat(payment.expiryAt, true) }}</div>
                            <div class="transaction-time" v-else>Created On: {{ HumanReadableDateFormat(payment.created_at) }}</div>
                        </div>
                        <div class="text-right">
                            <div class="transaction-amount" v-if="payment.isTrialPeriod == false">£{{ payment.priceDetails.unit_amount / 100 }}</div>
                            <span class="status status-confirmed" v-if="payment.status != 'Fail'">{{ payment.status }}</span>
                            <span class="status status-pending" v-else>{{ payment.status }}</span>
                        </div>
                    </div>
                 </div>    
            </div>
            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>

<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";

export default {
  name: 'Payment History',
  components: {
    KidHeader,
    KidFooter
  },
  data() {
    return {
        profileId: this.$route.query.profileId,
        paymentHistoryData: [],
        filteredPaymentHistoryData: [],
        today: new Date(),
        summaryStats: {
          "Active Subscriptions": 0,
          "Used Subscriptions": 0,
          "Unused Subscriptions": 0,
          "Expired Subscriptions": 0,
          "Device Purchases": 0,
          "Trial Subscriptions": 0,
          "Total Spent (£)": 0,
      },
      selectedFilter: null, // Track the selected filter state
    }
  },
  methods: {
    async getPaymentHistory() {
      await KidsService.getPaymentHistory()
        .then((response) => {
          this.paymentHistoryData = response.data.data;
          this.filteredPaymentHistoryData = this.paymentHistoryData; // Set initial filtered data

          // Calculate summary
          let totalSubs = 0, usedSubs = 0, expiredSubs = 0, activeSubs = 0;
          let unusedSubs = 0, devicePurchases = 0, trialSubs = 0, totalAmount = 0;

          this.paymentHistoryData.forEach(payment => {
            if (payment.subscriptionType === 'recurring') {
              totalSubs++;

              // Check if the subscription is used or not
              if (payment.serialNumber) usedSubs++;

              // Calculate active and expired subscriptions
              if (new Date(payment.expiryAt) < this.today) expiredSubs++;
              else activeSubs++;

              // If it's active and unused, increment unusedSubs
              if (new Date(payment.expiryAt) >= this.today && !payment.serialNumber) {
                unusedSubs++;
              }

              // Handle trial subscriptions and calculate total amount
              if (payment.isTrialPeriod) trialSubs++;
              if (!payment.isTrialPeriod && payment.priceDetails?.unit_amount) {
                totalAmount += payment.priceDetails.unit_amount / 100;
              }
            }

            if (payment.subscriptionType === 'one_time') {
              devicePurchases++;
              if (payment.priceDetails?.unit_amount)
                totalAmount += payment.priceDetails.unit_amount / 100;
            }
          });

          // Update summary stats
          this.summaryStats = {
            "Active Subscriptions": activeSubs,
            "Used Subscriptions": usedSubs,
            "Unused Subscriptions": unusedSubs, // Update unused subscriptions count
            "Expired Subscriptions": expiredSubs,
            "Device Purchases": devicePurchases,
            "Trial Subscriptions": trialSubs,
            "Total Spent (£)": totalAmount.toFixed(2),
          };

          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    
    // Filter payment history based on selected state
    applyFilter(filterKey) {
      this.selectedFilter = filterKey;
      this.filterPayments(filterKey);
    },

    // Clear the filter and show all data
    clearFilter() {
      this.selectedFilter = null;
      this.filteredPaymentHistoryData = this.paymentHistoryData;
    },

    // Apply the filter based on selected state
    filterPayments(filterKey) {
      switch(filterKey) {
        case "Active Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => new Date(payment.expiryAt) >= this.today && payment.subscriptionType === 'recurring');
          break;
        case "Used Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => payment.serialNumber && payment.subscriptionType === 'recurring');
          break;
        case "Expired Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => new Date(payment.expiryAt) < this.today && payment.subscriptionType === 'recurring');
          break;
        case "Device Purchases":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => payment.subscriptionType === 'one_time');
          break;
        case "Trial Subscriptions":
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => payment.isTrialPeriod && payment.subscriptionType === 'recurring');
          break;
        case "Unused Subscriptions":
          // Filter for active subscriptions with no serial number (unused)
          this.filteredPaymentHistoryData = this.paymentHistoryData.filter(payment => 
            payment.subscriptionType === 'recurring' &&
            new Date(payment.expiryAt) >= this.today && // Only active subscriptions
            !payment.serialNumber // Only those without serial numbers
          );
          break;
        default:
          this.filteredPaymentHistoryData = this.paymentHistoryData;
      }
    },

    HumanReadableDateFormat(date, onlyDate = false) {
      const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
      let dt = new Date(date);
      let day = ("0" + dt.getDate()).slice(-2);
      let month = dt.getMonth();
      let year = dt.getFullYear();
      let hour = ("0" + dt.getHours()).slice(-2);
      let minute = ("0" + dt.getMinutes()).slice(-2);
      let seconds = ("0" + dt.getSeconds()).slice(-2);
      if (onlyDate == true) {
          return day + " " + monthNames[month] + " " + year;
      } else {
          return day + " " + monthNames[month] + " " + year + " " + hour + ":" + minute + ":" + seconds;
      }
    },
  },
  beforeMount() {
    this.getPaymentHistory();
  },
}
</script>

<style scoped>
.summary-section {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.summary-box {
    background: white;
    border: 1px solid #dee2e6;
    padding: 12px;
    border-radius: 6px;
    margin-bottom: 15px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s;
}

.summary-label {
    font-size: 0.7rem;
    color: #6c757d;
}

.summary-value {
    font-size: 1.25rem;
    font-weight: bold;
    color: #343a40;
}

.summary-box:hover {
    background-color: #f1f1f1;
    border-color: #ccc;
}

.active-filter {
    background-color: #007bff;
    color: white;
    border-color: #0056b3;
}

.clear-filter {
    margin-top: 15px;
    text-align: right;
}

.clear-filter button {
    padding: 8px 16px;
    background-color: #f8f9fa;
    border: 1px solid #ccc;
    border-radius: 5px;
    color: #007bff;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.clear-filter button:hover {
    background-color: #007bff;
    color: white;
}

.clear-filter button:focus {
    outline: none;
}
</style>
